export default __webpack_public_path__ + "static/media/mainscreen.3b2c5d57.png";